"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
function ResultListItem(props) {
    var listItemRef = props.listItemRef, icon = props.icon, value = props.value, result = props.result, isSelected = props.isSelected, selectResultByClickFn = props.selectResultByClickFn, handleResultToStrFn = props.handleResultToStrFn;
    var listItemText = typeof handleResultToStrFn === 'function' ? handleResultToStrFn(result) : value;
    return (react_1.default.createElement(core_1.ListItem, { button: true, ref: listItemRef, selected: isSelected, onClick: selectResultByClickFn },
        react_1.default.createElement(core_1.Box, { display: 'flex', alignItems: 'center' },
            icon && (react_1.default.createElement(core_1.Box, { display: 'flex', alignItems: 'center', padding: 0.5 }, icon)),
            react_1.default.createElement(core_1.ListItemText, { primary: listItemText }))));
}
;
exports.default = ResultListItem;
